import { graphql, useStaticQuery } from 'gatsby'

/**
 * Returns a list of all site page paths.
 *
 * @example
 *     const paths = useSiteList()
 *     // => ['/home.html', '/xyz.html']
 */

const useSiteList = () => {
  const { nodes } = useStaticQuery(QUERY).allSitePage
  return nodes.map(node => node.path)
}

const QUERY = graphql`
  {
    allSitePage {
      nodes {
        path
      }
    }
  }
`

export default useSiteList
